import script from "./CardEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardEditView.vue?vue&type=script&setup=true&lang=js"

import "./CardEditView.vue?vue&type=style&index=0&id=dd00bcac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd00bcac"]])

export default __exports__